/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   17/10/2022
 */

import React, { useState } from "react";
import { Badge, Box, Fade, Grid, IconButton, Link, Paper, Popover, Stack, Tooltip, Typography } from "@mui/material";
import AppsIcon from '@mui/icons-material/Apps';
import CsatImage from "../media/images/csat.svg";
import CaseReviewsImage from "../media/images/case-reviews.svg";
import BonfireNotificationsImage from "../media/images/bonfire-notifications.svg";

export interface AppInfo {
	name: string
	goUrl: string
	imageSrc: any
}

const apps: AppInfo[] = [
	{
		name: "Cloud Deployments",
		goUrl: "cloud-deployments",
		imageSrc: "https://cloud-deployments.prod.atl-paas.net/img/cloud.png"
	}, {
		name: "CSAT Portal",
		goUrl: "csat",
		imageSrc: CsatImage
	}, {
		name: "Case Reviews",
		goUrl: "case-reviews",
		imageSrc: CaseReviewsImage
	}, {
		name: "Bonfire Notifications",
		goUrl: "bonfire-notifications",
		imageSrc: BonfireNotificationsImage
	}
]

const LAST_SEEN_VERSION_KEY = "vega.last-seen-apps";
const lastSeenTarget = "1";

export default function AppsMenu() {

	const lastSeenNumber = localStorage.getItem(LAST_SEEN_VERSION_KEY);

	const [badgeEnabled, setBadgeEnabled] = React.useState(lastSeenNumber !== lastSeenTarget);
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
	const isOpen = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		localStorage.setItem(LAST_SEEN_VERSION_KEY, lastSeenTarget);
		setBadgeEnabled(false);
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<Box>
			<Tooltip title={"Apps"} placement={"right"}>
				<IconButton onClick={handleClick} sx={{ color: "#fff" }} size="large">
					<Badge
						variant={"dot"}
						badgeContent={badgeEnabled ? "" : 0}
						color={"error"}
					>
						<AppsIcon />
					</Badge>
				</IconButton>
			</Tooltip>
			<Popover
				open={isOpen}
				anchorEl={anchorEl}
				onClose={handleClose}
				TransitionComponent={Fade}
				anchorOrigin={{
					vertical: 'center',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
			>
				<Stack>
					<Box sx={{ p: 1 }}>
						<Grid container sx={{ width: 440 }} spacing={1}>
							{apps.map(app =>
								<Grid item xs={6} key={app.name}>
									<Link href={"https://go.atlassian.com/" + app.goUrl} sx={{ width: "100%" }} target={"_blank"} onClick={() => handleClose()}>
										<Paper
											variant={"outlined"}
											sx={{
												borderRadius: 4,
												p: 1,
												width: "100%",
												'&:hover': {
													transform: 'scale(1.05)',
												},
										}}
										>
											<Stack sx={{ alignItems: "center" }}>
												<img src={app.imageSrc} alt={""} width={100} height={100} />
												<Typography>
													{app.name}
												</Typography>
												<Typography variant={"body2"}>
													go/{app.goUrl}
												</Typography>
											</Stack>
										</Paper>
									</Link>
								</Grid>
							)}
						</Grid>
					</Box>
				</Stack>
			</Popover>
		</Box>
	);

}